var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import sizes from './sizes';
export default function SearchIcon(_a) {
    var { size = 'small' } = _a, rest = __rest(_a, ["size"]);
    return (_jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", sx: {
            width: sizes[size],
            height: sizes[size],
            verticalAlign: 'middle',
            color: 'currentColor',
        } }, rest, { viewBox: "0 0 30 30", children: _jsx("g", { children: _jsx("path", { fill: "currentColor", fillRule: "evenodd", d: "M12.75 22.5C7.365 22.5 3 18.135 3 12.75S7.365 3 12.75 3s9.75 4.365 9.75 9.75a9.712 9.712 0 01-2.346 6.344l6.775 6.774a.75.75 0 01-1.06 1.06l-6.775-6.774A9.712 9.712 0 0112.75 22.5zm0-1.5a8.25 8.25 0 100-16.5 8.25 8.25 0 000 16.5z" }) }) })));
}
//# sourceMappingURL=SearchIcon.js.map